import UploadFailed from '../../src/legacy/UploadFailed';
export default UploadFailed;
